import Chip from '@mui/material/Chip';
import { useTheme } from '@mui/material/styles';
import { InvoiceCategoryFilter } from '@treadinc/horizon-api-spec';
import { memo, useCallback } from 'react';

import { ROUTES } from '~router/routePaths';

interface SettlementChipProps {
  settlementId: string;
  category?: InvoiceCategoryFilter;
}

const SettlementChip = memo(function SettlementChip({
  settlementId,
  category,
}: SettlementChipProps) {
  const theme = useTheme();
  const handleClick = useCallback(() => {
    const categoryParam = category ?? InvoiceCategoryFilter.PAYABLES;
    const url = `/${ROUTES.approvals.base}/${ROUTES.approvals.driverPay}?category=${categoryParam}&tab=settlements&search=${encodeURIComponent(settlementId)}`;
    window.open(url, '_blank');
  }, [settlementId, category]);

  return (
    <Chip
      label={settlementId}
      size="small"
      variant="outlined"
      color="default"
      onClick={handleClick}
      sx={{
        textTransform: 'none',
        cursor: 'pointer',
        '&:hover .MuiChip-label': {
          textDecoration: 'underline',
        },
        '&:hover': {
          backgroundColor: theme.brandV2.colors.treadGray8,
        },
      }}
    />
  );
});

export default SettlementChip;
